var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHlpContSupport(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.5 10.1833C17.5 5.60833 13.95 2.5 9.99996 2.5C6.09163 2.5 2.49996 5.54167 2.49996 10.2333C1.99996 10.5167 1.66663 11.05 1.66663 11.6667V13.3333C1.66663 14.25 2.41663 15 3.33329 15H4.16663V9.91667C4.16663 6.69167 6.77496 4.08333 9.99996 4.08333C13.225 4.08333 15.8333 6.69167 15.8333 9.91667V15.8333H9.16663V17.5H15.8333C16.75 17.5 17.5 16.75 17.5 15.8333V14.8167C17.9916 14.5583 18.3333 14.05 18.3333 13.45V11.5333C18.3333 10.95 17.9916 10.4417 17.5 10.1833V10.1833Z",
    fill: "#5F488A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.49996 11.6667C7.9602 11.6667 8.33329 11.2936 8.33329 10.8333C8.33329 10.3731 7.9602 10 7.49996 10C7.03972 10 6.66663 10.3731 6.66663 10.8333C6.66663 11.2936 7.03972 11.6667 7.49996 11.6667Z",
    fill: "#5F488A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 11.6667C12.9602 11.6667 13.3333 11.2936 13.3333 10.8333C13.3333 10.3731 12.9602 10 12.5 10C12.0397 10 11.6666 10.3731 11.6666 10.8333C11.6666 11.2936 12.0397 11.6667 12.5 11.6667Z",
    fill: "#5F488A"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15 9.19167C14.8013 8.02011 14.1945 6.95664 13.2871 6.18948C12.3796 5.42233 11.23 5.00098 10.0417 5C7.51668 5 4.80002 7.09167 5.01668 10.375C6.04429 9.95449 6.95188 9.28624 7.65854 8.42982C8.36519 7.5734 8.84895 6.55543 9.06668 5.46667C10.1583 7.65833 12.4 9.16667 15 9.19167Z",
    fill: "#5F488A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHlpContSupport);
export default __webpack_public_path__ + "static/media/hlp_contSupport.e226e1fd8f65397cca34fe67c5461eff.svg";
export { ForwardRef as ReactComponent };